import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faStroopwafel,
  faArrowRight,
  faEnvelope,
  faMapMarker,
  faPhone,
  faCircle,
  faAngleDown,
  faAngleUp,
  faMapMarkerAlt,
  faSearch,
  faCaretUp,
  faBriefcase,
  faTags,
  faThLarge,
  faTrashAlt,
  faPencilAlt,
  faEllipsisH,
  faSpinner,
  faWrench,
} from "@fortawesome/free-solid-svg-icons"
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons"
import brands from "@fortawesome/fontawesome-free-brands"

library.add(
  faStroopwafel,
  faArrowRight,
  brands,
  faEnvelope,
  faMapMarker,
  faPhone,
  farCircle,
  faCircle,
  faAngleDown,
  faAngleUp,
  faMapMarkerAlt,
  faSearch,
  faCaretUp,
  faBriefcase,
  faTags,
  faThLarge,
  faTrashAlt,
  faPencilAlt,
  faEllipsisH,
  faSpinner,
  faWrench
)



// WEBPACK FOOTER //
// src/icons.js